export default __webpack_public_path__ + "static/bg-grey-ad365512e979b6e7c63f3d8b2bd506d8.jpg";